import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'

//  http://wiki.xunlei.cn/pages/viewpage.action?pageId=122783960
export const mission_entrance = createAsyncThunk(
  '/live/vip/mission_entrance',
  async (arg, store: any) => {
    const resp = await http.post<HiyaRes<InitialStateType['mission']>>(
      '/live/vip/mission_entrance',
      {
        ...store.getState().env.deviceinfo,
      }
    )
    return resp.data.data
  }
)

// http://wiki.xunlei.cn/pages/viewpage.action?pageId=122784058
export const mission_complete = createAsyncThunk(
  '/live/vip/mission_complete',
  async (
    arg: {
      id: number
    },
    store: any
  ) => {
    const resp = await http.post<
      HiyaRes<{
        image: string
        content: string
      }>
    >('/live/vip/mission_complete', {
      ...store.getState().env.deviceinfo,
      id: arg.id,
    })
    return resp.data.data
  }
)

// http://wiki.xunlei.cn/pages/viewpage.action?pageId=122784058
export const buff_party = createAsyncThunk(
  '/live/vip/buff_party',
  async (arg, store: any) => {
    const resp = await http.post<
      HiyaRes<{
        image: string
        content: string
      }>
    >('/live/vip/buff_party', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data.data
  }
)

export enum StatusEnum {
  未完成 = 0,
  完成未领取 = 1,
  已领取 = 2,
}
export interface InitialStateType {
  mission: {
    level?: number
    exp?: number
    list?: Array<{
      id: number
      title: string
      icon: string
      max_score: number
      current_score: number
      status: StatusEnum
      content: string
      scheme: string
    }>
  }
  carnival: {
    is_continuous?: boolean
    continuous_level?: number
    continuous_count?: number
    already_count?: number
    buff_level?: number
    get_buff_status?: 0 | 1 | 2
    buff_ext_exp?: number
    buff_ratio?: number
    st?: string
    et?: string
    gift_banner_skin?: string
    gift_float_skin?: string
  }
}

const initialState: InitialStateType = {
  mission: {},
  carnival: {},
}

export const VipMissionSlice = createSlice({
  name: 'Animal_Ant',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(mission_entrance.fulfilled, (state, action) => {
      Object.assign(state.mission, action.payload)
    })
    builder.addCase(buff_party.fulfilled, (state, action) => {
      Object.assign(state.carnival, action.payload)
    })
  },
})
export default VipMissionSlice.reducer
export const VipMissionActions = VipMissionSlice.actions

export const useVipMissionState = () => {
  const data = useSelector((state) => {
    return state.Animal_Ant
  })
  return data
}
